import Minivan from "./Minivan";

export default Minivan;